import PropTypes from 'prop-types';

import css from 'styles/zen/finalSale.scss';

const FinalSale = (_, { marketplace: { pdp: { showFinalSale } }, testId }) => {
  if (!showFinalSale) {
    return null;
  }

  return (
    <em className={css.container} data-test-id={testId('finalSale')}>Final Sale</em>
  );
};

FinalSale.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default FinalSale;
